// 自主智能体
export const AutonomousAgentCode = 'autonomous_agent';
// 通用智能体
export const GeneralAgentCode = 'general_agent';
